import { useNotifier } from "../../services/customHooks/useNotifier";
import React, { useEffect } from "react";

type NotifierProps = {
  variant?: "default" | "success" | "error" | "warning" | "info";
  message: string;
  autoHideDuration?: number;
};

const Notifier: React.FC<NotifierProps> = ({
  variant = "default",
  message,
  autoHideDuration = 3000,
}) => {
  const { notify } = useNotifier();

  useEffect(() => {
    if (message) {
      notify({ message, variant, autoHideDuration });
    }
  }, [message, variant, autoHideDuration, notify]);

  return null; // this component just triggers the snackbar
};

export default Notifier;
